import { Autocomplete, Button, Dialog, DialogContent, DialogTitle, Grid, List, ListItemButton, TextField, Tooltip, Typography } from '@mui/material';
import {useState, useEffect} from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./EmailTab.css";
import DeviceConfigModal from '../../UserScreen/InventoryPage/InventorySettings/components/Modals/DeviceConfigModal';
import EmailTab from './EmailTab';
import {createSmtpEmailData, getSendGridTableData, createDNSData, activateSendGrid, activateSmtp, activateMsgraph} from "../../actions/Users/authenticateGroupSettings";

const AuthenticationService = (props) => {
    const {authenticateServiceOpen, setAuthenticateServiceOpen, selectedService, setSelectedService, dpId, ouName, whitelabeled, createSmtpEmailData, getSendGridTableData, createDNSData, activateSendGrid, activateSmtp, activateMsgraph, handleAuthenticateServiceClose} = props;
    const [selectedAction, setSelectedAction] = useState("Email");
    const [data, setdata] = useState([]);
    const [email, setEmail] = useState("");
    const [testmailValid, setTestmailvalid] = useState(false);
    const handleClose = () => {
        setAuthenticateServiceOpen(false);
    }
    const handleChangeActionType = (action) => {
        setSelectedAction(action);
    }
    const tabs = ["Email"]
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

    const handleTabChange = (label: string, index: number) => {
        setActiveTabIndex(index);
        setAuthenticateServiceOpen(false);
    }


    const handleSave = () => {
        const payload = {
            "emailType": selectedService
        }
        switch(selectedService){
            case "SMTP" :
                activateSmtp(dpId, payload);
                break;
            case "SendGrid":
                activateSendGrid(dpId, payload);
                break;
            case "Microsoft Graph API":
                activateMsgraph(dpId, payload);
                break;
            default:
                console.log("service",selectedService);
                break;
        }
    }
    const handleCancel = () => {
        setAuthenticateServiceOpen(false);
    }
    const renderTabContent = (index: number): JSX.Element | null => {
        switch (index) {
          case 0:
            return <div>
                <EmailTab selectedService={selectedService} setSelectedService={setSelectedService} dpId={dpId} testmailValid={testmailValid} setTestmailvalid={setTestmailvalid} whitelabeled={whitelabeled}/>
            </div>;
          default:
            return null;
        }
      };
    const handleDisableTransfer = () => {

    }
    return (
            <div>
                <DeviceConfigModal
                    open={authenticateServiceOpen}
                    setOpen={setAuthenticateServiceOpen}
                    deviceName={ouName}
                    cancelText="Cancel"
                    saveText = "Activate"
                    tabLabels={tabs}
                    activeTabIndex={activeTabIndex}
                    onTabSwitch={handleTabChange}
                    onSave={handleSave}
                    onCancel={handleAuthenticateServiceClose}
                    renderTabContent={renderTabContent}
                    showOnlineStatus={false}
                    showOnlineOffline={false}
                    showSyncStatus={false}
                    disableSave={!testmailValid}
                    height="480px"
                    width="800px"
                    footer={true}
                />
            </div>
        )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
});

export default withRouter(
    connect(mapStateToProps, {
        createSmtpEmailData, getSendGridTableData, createDNSData, activateSendGrid, activateSmtp, activateMsgraph
    })(AuthenticationService)
)